import { CategoryWithId } from "../interfaces/ICategories";
import { findCategoryById } from "../utils/firestore";
import { useEffect, useState } from "react";

export const useCategory = (contestId: string, categoryId: string) => {
  const [category, setCategory] = useState<CategoryWithId | null>(null);

  useEffect(() => {
    if (contestId && categoryId) {
      findCategoryById(contestId, categoryId).then((data) => {
        setCategory(data);
      });
    }
    //eslint-disable-next-line
  }, []);

  return { category, setCategory };
};
